import constants from './constants/constantsMain';
import services from './services/servicesMain';

export const common = {
    constants: constants,
    services: services
};